// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"605":"e980f275","805":"53b511d5","892":"6fa9a6b3"}[chunkId] + ".css";
};